var exports = {
  "G9": "x8b4e8595--56de59--pagination-error",
  "Ln": "x8b4e8595--56de59--pagination-error-button",
  "Se": "x8b4e8595--56de59--pagination-sentinel",
};

module.exports = exports;
